import { render, staticRenderFns } from "./SelectReviewPop.vue?vue&type=template&id=2fc5751e&scoped=true"
import script from "./SelectReviewPop.vue?vue&type=script&lang=ts"
export * from "./SelectReviewPop.vue?vue&type=script&lang=ts"
import style0 from "./SelectReviewPop.vue?vue&type=style&index=0&id=2fc5751e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc5751e",
  null
  
)

export default component.exports